import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Icon from '../../../../core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
var useStyles = makeStyles({
  iconSize: {
    fontSize: '16px'
  },
  checked: {
    // border: '1px solid rgba(0,0,0,0.3)',
    background: 'rgba(0,0,0,0.05)'
  }
}, {
  name: 'ECToggleIcon'
});

var ToggleIcon = function ToggleIcon(_ref) {
  var _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      restProps = _objectWithoutProperties(_ref, ["checked"]);

  var classes = useStyles({});
  return React.createElement(Icon, Object.assign({
    buttonSize: "medium",
    className: classes.iconSize,
    buttonProps: {
      className: cx(checked && classes.checked)
    }
  }, restProps));
};

export default ToggleIcon;